export const TOGGLE_LOADER = "TOGGLE_LOADER";

export const CHANGE_STATUS = "CHANGE_STATUS";
export const GET_PROFILE = "GET_PROFILE";

export const SET_STATE = "SET_STATE";

export const CHANGE_PROGRESS = "CHANGE_PROGRESS";

export const GET_CREDIT_INFO = "GET_CREDIT_INFO";
